import { css, cx } from "@emotion/css";
import { Modal as MuiModal } from "@mui/material";
import type React from "react";
export interface ModalProps {
    open: boolean;
    children: React.ReactElement;
    className?: string;
}
/* @deprecated
Deprecated: 13/01/2026
Replacement: Dialog components
Reason: This component is deprecated and will be removed in a future release.
*/
export function DeprecatedModal({ open, className, children }: ModalProps) {
    return (<MuiModal open={open} className={cx(styles, className)}>
            {children}
        </MuiModal>);
}
const styles = css({
    "&&": {
        zIndex: "auto",
        isolation: "isolate",
    },
});
